module.exports = __webpack_public_path__ + "assets/img_drizzly.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_drizzly.jpg
 ** module id = 121
 ** module chunks = 1
 **/